<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-barcode"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('barcodes') }}
        </div>
      </template>
      <v-row class="mx-0">
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @keydown.enter="getDataFromApi"
          @blur="getDataFromApi"
        />
      </v-row>

      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
        @current-items="fixRowColors()"
      >
        <template v-slot:item.out="{item}">
          <div :class="item.out && 'out'">
            <v-icon
              v-if="!item.out"
              color="green"
            >
              check
            </v-icon>
            <v-icon
              v-else
              color="red"
            >
              not_interested
            </v-icon>
          </div>
        </template>
        <template v-slot:item.customer="{item}">
          {{ item.customer ? (item.customer.company_name || item.customer.name) + " ("+item.customer.id+")" : '' }}
        </template>
        <template v-slot:item.created_at="{item}">
          {{ convertUTCToLocal(item.created_at) }}
        </template>

        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              medium
              class="mr-5"

              color="green"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              medium
              color="red"
              class="mr-5"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
      <v-col>
        <v-row>
          <v-btn
            color="green"
            class="ml-auto mt-5"
            @click="editItem({id: null})"
          >
            <v-icon class="mr-3">
              mdi-plus
            </v-icon>
            {{ $t('new') }}
          </v-btn>
        </v-row>
      </v-col>
    </base-material-card>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('barcode') }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="editedItem.identifier"
                  :label="$t('identifier')"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="editedItem.prefix"
                  :label="$t('prefix')"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="editedItem.start"
                  :label="$t('start')"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="editedItem.end"
                  :label="$t('end')"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="editedItem.index"
                  :label="$t('index')"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <v-text-field
                  v-model="editedItem.left || editedItem.end - editedItem.start - editedItem.index"
                  :label="$t('left')"
                  disabled
                />
              </v-col>
              <v-col
                cols="12"
              >
                <base-paginated-select
                  :selected="editedItem.customer"
                  endpoint="customers"
                  :label="$t('customer')"
                  item-text="company_name"
                  selected-item-text="company_name"
                  :params="{
                    filters: { business: 1 },
                  }"
                  @value-change="val => editedItem.customer = val"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'
  import { ROLES } from '../../../utils/constants'

  export default {
    mixins: [List],
    data () {
      return {
        endpoint: 'barcodes',
        name: 'barcode',
        crudl: {
          C: ROLES.ECONOMY,
          U: ROLES.ECONOMY,
          D: ROLES.ECONOMY,
        },
        headers: [
          {
            text: this.$t('customer'),
            value: 'customer',
          },
          {
            sortable: false,
            text: this.$t('identifier'),
            value: 'identifier',
            width: '100%',
          },
          {
            sortable: false,
            text: this.$t('prefix'),
            value: 'prefix',
          },
          {
            text: this.$t('start'),
            value: 'start',
          },
          {
            text: this.$t('end'),
            value: 'end',
          },
          {
            text: this.$t('index'),
            value: 'index',
          },
          {
            text: this.$t('left'),
            value: 'left',
          },
          {
            text: this.$t('active'),
            value: 'out',
          },
          {
            text: this.$t('created'),
            value: 'created_at',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },

        ],
        editedItem: {
          identifier: '',
          prefix: '',
          start: '',
          end: '',
          index: '',
          left: '',
          customer: {},
          out: false,
        },
        defaultItem: {
          identifier: '',
          prefix: '',
          start: '',
          end: '',
          index: '',
          left: '',
          customer: {},
          out: false,
        },
      }
    },
    methods: {
      fixRowColors: function () {
        setTimeout(() => {
          const rows = document.querySelectorAll('table tbody tr')
          rows.forEach(x => {
            const special = x.querySelector('div.out')
            if (special) {
              x.classList.add('out')
            }
          })
        }, 200)
      },
    },
  }
</script>

<style lang="sass">
tr.out
  background-color: rgba(255, 0, 0, 0.25)

</style>
